import React from 'react';
import styled from 'styled-components';
import DynamicImage from '../../../atoms/DynamicImage';
import colors from '../../../../helpers/colors';

const Container = styled.div`
    width: 100%;
    margin: 80px 0 0 0;
    background: 
    padding: 0; 
    box-sizing: border-box; 
    background-color: ${colors.mvLightGrey};
    overflow: hidden;

    .gatsby-image-wrapper-constrained {
        max-width: none;
        display: block;
        height: auto;
        transform: translateY(0%);

    }
`;

const HeaderImage = ({
    image,
    imageAlt,
}) => {  
    return (
        <Container>
            <DynamicImage src={image} alt={imageAlt} />
        </Container>
    );
};

export default HeaderImage;
